import {
    UPDATE_PAGE,
    OPEN_MOBILE_MENU
} from "../constants/appConstants";

import {open as samplesOpened} from "./samplesActions";

/*
 * action creators
 */
const updatePage = (pathname) => {
    return { type: UPDATE_PAGE, payload: pathname }
};

export const update = (data) => {
    return (dispatch) => {
        return dispatch(updatePage(data));
    };
}

const openMobMenu = (isOpened) => {
    return { type: OPEN_MOBILE_MENU, payload: isOpened }
};

export const openMobileMenu = (isOpened) => {
    return (dispatch, getState) => {
        dispatch(openMobMenu(isOpened));
        if (isOpened && getState().samples.opened){
            dispatch(samplesOpened(false));
        }
    };
}